// extracted by mini-css-extract-plugin
export default {"title":"FinancialMonthly_title_cZ0BR","total":"FinancialMonthly_total_s1Cxc"};